import Vue from 'vue'
import Vuex from 'vuex'
import { getUserInfo, login,logoutApi } from '@/api/login'//登录的接口
import assist from '@/utils/commonality' //公共的方法
import { getspQuest} from '@/api/upload' //封装的加密接口

import modela from './thistimedata'


// 本次项目的  

Vue.use(Vuex)
 
// 用来存储数据
const state = {
    uid:assist.getCache('uid') || '',
    userInfo:assist.getCache('userinfo') || {},
    loginVisible:false,//全局控制登录弹出层
    ispopvip:false ,//全局控制vip会员的弹出层
    datedetainment:false,//挽留弹窗的全局控制
    touxiangcard:false,//控制点击头像后的小卡片
    grzx:false,//全局控制个人中心弹出层
    loading: false,//全局禁止点击的遮罩层
    sign:assist.getCache('sign') || '',//三方签名
    configforChannel:assist.getCache('configforChannel') ||  {},//客服一类的信息
    newconfig:assist.getCache('newconfig') || {},
    // 本次项目的
    topactive:assist.getCache('topactive') || 0,
}
// 响应组件中的事件
const actions = {
  async login(context, val) {//手机号登录的逻辑
    try {
      // 登录并获取用户 UID  
      const loginResponse = await login(val);
      let  uid = loginResponse.data.uid
      let jwt  = loginResponse.data.jwt
      if (uid) {
           // 将 UID 存入 Vuex 状态
      context.commit('loginMutations', uid);
      assist.setCache('uid',uid) //本地存入uid
      assist.jwt.set(jwt) //本地存入jwt
      context.dispatch('getuserinfo') //通过uid调用获取用户信息
      return {success:true,data:loginResponse.data}
      }else {
        return {success:false,message:'登录失败，未获取到用户UID'}
      }
    } catch (error) {
      return {success:false,error:error.message||'登录过程中发生错误'}
    }
  },
 async logout(context,val) {//退出的
     try {
         await logoutApi()
         assist.clearCache('uid')
         assist.clearCache('userinfo')
         assist.jwt.clear();
         context.commit('updatelogout')
         assist.clearCache('sign')

         return {success:true}
     } catch (error) {
      return {success:false,error:error.message||'请稍后重试'}
     }
    },
   async getuserinfo(context,val) { //通过uid拿到用户信息
        const userInfoResponse = await getUserInfo();
        context.commit('getUserInfo', userInfoResponse.data);//存入state
        assist.jwt.set(userInfoResponse.data.jwt);//本地存入jwt
        assist.setCache('userinfo', userInfoResponse.data, (new Date()).getTime() + 2700000);//存入用户信息
        assist.setCache('uid',userInfoResponse.data.uid);//存入用户信息
        context.dispatch('getSign',userInfoResponse) //调用获取签名的
    },
  async  getSign(context,val) {//获取签名
      let res =  await getspQuest('/api/cost/bySignInfo','post','17',{//拿到签名  类似于token
        token:val.data.jwt
      })
      assist.setCache('sign', res.data.sign); //本地存入签名
      context.commit('updateSign',res.data.sign) //修改state中的值
    },
    clickLoading({ commit },val) { //全屏开启禁止点击 element的
      commit('setLoading', val);
    },

  async getconfigforChannel(context,val) { //获取客服链接 及 同意协议的一些配置
            let res =    await getspQuest(
             '/api/basic/getCfgForChannel',
             'get',
             '1'
            )

            if (res.data.ability.used.func.domain_name_change == 1) {
              let hostname = window.location.hostname.split(".");
              hostname.shift();
              hostname = hostname.join('.');
             const newconfig = await getspQuest(
               '/api/basic/getDomainBodyInfo',
               'get',
               '1',
               {
                 domain: hostname.length ==0 ?  'sanwubeixin.cn' : hostname, //localhost
               }
           )
           assist.setCache('newconfig', newconfig.data); //newconfig 存入本地
           context.commit('updatenewconfig', newconfig.data) //newconfig 修改state的值
         }



      assist.setCache('configforChannel', res.data); //存入本地
      context.commit('updateconfigforChannel', res.data) //修改state的值
    },
    // 本次项目的

}
// 操作数据
const mutations = {
  loginMutations(state,val) { //修改uid的
    state.uid = val
  },
  getUserInfo(state,val) {//修改用户个人信息的
      state.userInfo = val
  },
  updateloginVisible(state,val) {//修改控制登录弹出层的
    if(val) {
      assist.manage({position: '全局登录'})//埋点全局登录
    }
      state.loginVisible = val
  },
  updatispopvip(state,val) {//修改控制vip弹出层的
    if(val) {
      assist.manage({position: '付费页调起'})//埋点全局登录
    }
    state.ispopvip = val
  },
  updatedetainment(state,val) {//修改挽留弹窗的弹出层
      state.datedetainment = val
  },
  updategrzx(state,val) { //修改个人中心弹出层
      state.grzx = val
  },
  updatelogout(state,val) {//退出
      state.userInfo = {}
      state.sign = ''
      state.uid = ''
  },
  setLoading(state, loading) { //禁止点击的遮罩层
    state.loading = loading;
  },
  updateSign(state,val) {//修改三方签名
    state.sign = val
  },
  updateconfigforChannel(state,val) {//修改客服一类的信息
    state.configforChannel = val
  },
  updatenewconfig(state,val) {//修改客服一类的信息
    state.newconfig = val
  },
  updatetouxiangcard(state,val) {//控制点击头像后的小卡片
    state.touxiangcard = val
  },

  // 本次项目的
  updatetopactive(state,val) {//顶部的切换
    state.topactive = val
  }
}
// 用来将state数据进行加工
const getters = {
    isuid:state => state.uid, //uid
    isloginVisible:state => state.loginVisible,//全局控制登录弹出层的
    isispopvip : state => state.ispopvip,//全局控制会员弹出层的
    isuserInfo :state => state.userInfo,//用户的信息
    isdatedetainment:state => state.datedetainment,//全局控制挽留弹出层的
    istouxiangcard:state => state.touxiangcard,//控制点击头像后的小卡片
    isgrzx:state => state.grzx,//全局控制个人中心弹出层的
    isstorpclick: state => state.loading,//禁止点击的遮罩层loading
    issign :state => state.sign,//三方的签名类似于token，有些接口需要这个值
    isconfigforChannel:state => state.configforChannel,//客服的一些信息 用户同意协议什么的
    isnewconfig:state => state.newconfig,//新config
    // 本次项目的  
    istopactive:state => state.topactive,//顶部的切换
  }
  const modules = {
    modela
  }
// 新建并暴露store
export default new Vuex.Store({
    state,
    actions,
    mutations,
    getters,
    modules
})
 